import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { JobLocation } from '@shared/models/job-location';

@Component({
  selector: 'mojo-job-location',
  templateUrl: './job-location.component.html',
  styleUrls: ['./job-location.component.scss']
})
export class JobLocationComponent implements OnChanges {

  @Input() locations: JobLocation[];

  @Input() showTooltip = true;

  defaultLocation: JobLocation | JobLocation[];


  get hasMultipleLocation() {
    return !!this.locations && this.locations.length > 1;
  }

  private setDefaultLocation() {
    this.defaultLocation = (this.hasMultipleLocation) ? this.locations :
      (this.locations) ? this.locations[0] : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setDefaultLocation();
  }
}
